module.exports = __webpack_public_path__ + "img/sp-1.c3a6b906.png";